import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import SlideshowOutlinedIcon from "@mui/icons-material/SlideshowOutlined";
import OndemandVideoOutlinedIcon from "@mui/icons-material/OndemandVideoOutlined";
import MusicNoteOutlinedIcon from "@mui/icons-material/MusicNoteOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";

const ICON_SIZE = "22px";

export const FileTypeIcon = (props: { fileName: string }) => {
    const { fileName } = props;
    const ext = fileName.split(".").pop()?.toLowerCase() ?? "";

    switch (ext) {
        // PDF
        case "pdf":
            return <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: ICON_SIZE, color: "#E53935" }} />;

        // Word documents
        case "doc":
        case "docx":
            return <DescriptionOutlinedIcon sx={{ fontSize: ICON_SIZE, color: "#1565C0" }} />;

        // Excel / spreadsheets
        case "xls":
        case "xlsx":
        case "csv":
            return <TableChartOutlinedIcon sx={{ fontSize: ICON_SIZE, color: "#2E7D32" }} />;

        // PowerPoint
        case "ppt":
        case "pptx":
            return <SlideshowOutlinedIcon sx={{ fontSize: ICON_SIZE, color: "#E65100" }} />;

        // Images
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "bmp":
        case "webp":
        case "svg":
            return <ImageOutlinedIcon sx={{ fontSize: ICON_SIZE, color: "#00838F" }} />;

        // Video
        case "mp4":
        case "avi":
        case "mov":
        case "mkv":
        case "webm":
            return <OndemandVideoOutlinedIcon sx={{ fontSize: ICON_SIZE, color: "#6A1B9A" }} />;

        // Audio
        case "mp3":
        case "wav":
        case "ogg":
        case "m4a":
            return <MusicNoteOutlinedIcon sx={{ fontSize: ICON_SIZE, color: "#AD1457" }} />;

        // Archives
        case "zip":
        case "rar":
        case "7z":
        case "tar":
        case "gz":
            return <FolderZipOutlinedIcon sx={{ fontSize: ICON_SIZE, color: "#F9A825" }} />;

        // Plain text
        case "txt":
        case "md":
            return <ArticleOutlinedIcon sx={{ fontSize: ICON_SIZE, color: "#546E7A" }} />;

        // Calendar
        case "ics":
            return <EventNoteOutlinedIcon sx={{ fontSize: ICON_SIZE, color: "#1565C0" }} />;

        default:
            return <InsertDriveFileOutlinedIcon sx={{ fontSize: ICON_SIZE, color: "#78909C" }} />;
    }
}